export var RoleEnum;
(function (RoleEnum) {
    RoleEnum[RoleEnum["SuperAdmin"] = 0] = "SuperAdmin";
    RoleEnum[RoleEnum["Admin"] = 1] = "Admin";
    RoleEnum[RoleEnum["User"] = 2] = "User";
})(RoleEnum || (RoleEnum = {}));
export const ActionTypeMapping = new Map([
    [RoleEnum.SuperAdmin, 'Super Admin'],
    [RoleEnum.Admin, 'Admin'],
    [RoleEnum.User, 'User']
]);
